// useRoles.ts
import { useMemo } from "react";


export type Roles = Record<string, boolean>;

const STORAGE_KEY = "roles";

const getStoredRoles = (): Roles => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed.roles as Roles; // unwrap
    } catch {
        return {};
    }
};

const useRoles = () => {
    const roles = useMemo(() => getStoredRoles(), []);

    const hasRole = (role: string): boolean => {
        if (!roles) return false;
        return !!roles[role];
    };

    const hasAnyRole = (roleList: string[]): boolean => {
        if (!roles) return false;
        return roleList.some((r) => roles[r]);
    };

    const hasAllRoles = (roleList: string[]): boolean => {
        if (!roles) return false;
        return roleList.every((r) => roles[r]);
    };

    return { roles, hasRole, hasAnyRole, hasAllRoles };
};

export default useRoles;
